import util from '../util'

let controller = 'Antifraudes'
export default {
  ObterEstatisticasPessoasComDetalhesPaginado: function (dto) {
    return util.Axios.GetAll('v1/' + controller + '/estatisticas-pessoas', dto)
  },
  ObterEstatisticasPessoa: function (documento) {
    return util.Axios.GetAll(`v1/${controller}/estatisticas-pessoa/${documento}?online=false`, {})
  },
  AtualizarEstatisticasPessoa: function (documento) {
    return util.Axios.Post(`v1/${controller}/estatisticas-pessoa/${documento}/atualizar`, {})
  },
  ObterDataHoraUltimaExecucao: function () {
    return util.Axios.Get('v1/' + controller + '/execucao-estatisticas-pessoas/ultima-execucao', null)
  },
  ObterTransacoesBloqueadas: function (dto) {
    return util.Axios.GetAll('v1/' + controller + '/transacoes-bloqueadas', dto)
  },
  GerarExcelRelatorioTransacoesBloqueadas: function (dto) {
    return util.Axios.GetAll('v1/' + controller + '/transacoes-bloqueadas-xlsx', dto)
  }
}
